/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/

import Footer from "./Footer";

export default Footer;
